import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import InvoiceTemplateForm from "@components/forms/InvoiceTemplateForm";
import AddProductToDocumentOffCanvas from "@components/layout/Offcanvas/AddProductToDocumentOffCanvas";
import DocumentOtherChargesOffCanvas from "@components/layout/Offcanvas/DocumentOtherChargesOffCanvas";
import { useAppSelector } from "@/store/hooks";
import { OpenDocumentOtherChargesPubSub } from "@utils/pubsubs/PubSub";

type InvoiceTemplateAddEditProps = {
  copyData?: boolean
}

const InvoiceTemplateAddEdit = (props: InvoiceTemplateAddEditProps) => {
  const params = useParams()
  const { copyData = false } = props
  const documentOtherCharges = useAppSelector((state) => state.eDocument.documentOtherCharges)
  const { id: copyInvoiceTemplateId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Plantilla de Factura"
      backUrl="/user/invoicetemplates"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "invoiceTemplateAdd",
          type: "submit",
          color: "success"
        },
        {
          customElement: (
            <AddProductToDocumentOffCanvas
              hideTemplate={true}
              btnColor="success">
              Agregar Producto
            </AddProductToDocumentOffCanvas>
          )
        }
      ]}
      secondaryActions={[
        {
          actionTitle: `Otros Cargos (${documentOtherCharges.length})`,
          onClick: () => {
            OpenDocumentOtherChargesPubSub.publish({ openOffCanvas: true, documentKind: "Invoice" })
          }
        },
      ]}
    >
      <InvoiceTemplateForm
        id={copyInvoiceTemplateId}
        copyData={copyData}
        saveRedirectUrl="/user/invoicetemplates"
        formId="invoiceTemplateAdd" >
      </InvoiceTemplateForm>

      <DocumentOtherChargesOffCanvas />

    </PageContainer>
  );
}

export default InvoiceTemplateAddEdit;
